import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { purchaseReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const purchaseReportRouteMetadata: IRouteMetadataObj<
  typeof purchaseReportRoutesObj
> = {
  list: {
    title: "reportManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/reportManagement/purchaseReport/table/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const purchaseReportRoutes = createRoute<typeof purchaseReportRoutesObj>(
  purchaseReportRoutesObj,
  purchaseReportRouteMetadata,
);
